import { Injectable } from '@angular/core';
import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';
import { Pagination } from '../../../core/model';
import { AvailableSoldTosSearchParams, SoldTo } from '../../../core/model/user.model';
import { SOLD_TO_CORE_FEATURE } from '../store/sold-to-state';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: SoldToOnUserDetailsFacade,
      feature: SOLD_TO_CORE_FEATURE,
      async: true,
      methods: [
        'searchForAvailableSoldTosOnUserDetails',
        'getAvailableSoldTosOnUserDetails',
        'getAvailableSoldTosOnUserDetailsLoading',
        'getAvailableSoldTosOnUserDetailsPagination',
        'getSearchParametersForAvailableSoldTosOnUserDetails',
        'updateSearchParametersForAvailableOnUserDetailsSoldTos',
      ],
    }),
})
export abstract class SoldToOnUserDetailsFacade {
  abstract searchForAvailableSoldTosOnUserDetails(searchParams: AvailableSoldTosSearchParams): void;

  abstract getAvailableSoldTosOnUserDetails(): Observable<Array<SoldTo>>;

  abstract getAvailableSoldTosOnUserDetailsLoading(): Observable<boolean>;

  abstract getAvailableSoldTosOnUserDetailsPagination(): Observable<Pagination | undefined>;

  abstract getSearchParametersForAvailableSoldTosOnUserDetails(key: string): Observable<AvailableSoldTosSearchParams>;

  abstract updateSearchParametersForAvailableOnUserDetailsSoldTos(searchParams: AvailableSoldTosSearchParams);
}
